import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import serviceReducers from "./serviceReducers";
import { sibaBackendApi, sibaAuthApi } from "../services/backends/sibaApis";
/**
 * Configuring Redux store for application.
 * @prop reducer application reducers
 * @prop middleware  application middlewares
 * **/
export const store = configureStore({
    // reducer contains an object of all the created reducers
    reducer: { ...serviceReducers },
    //  apply  middlewares to redux store. add default middleware
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(sibaBackendApi.middleware, sibaAuthApi.middleware)
});
// Configure listeners with the recommended defaults,
setupListeners(store.dispatch);

// Getting the State type by returning the ReturnType of the above defined reducer.
export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
//  Export AppDispatch
//store uses dispatch method to dispatch actions.
export const AppDispatch = store.dispatch;
